import { useEffect, useRef, useCallback } from "react";
import { monitorResidentAuth } from "../services/delivery_api"; // Fixed import path

export const useDeliveryAuthPolling = (
  session,
  setSession,
  interval = 10000
) => {
  const intervalRef = useRef(null);
  const previousDeliveriesRef = useRef();

  const pollResidentAuth = useCallback(async () => {
    if (!session?.deliveries?.[0]?.session_file_name) return;

    const payload = {
      session_file_name: session.deliveries[0].session_file_name,
      complex_location: session.deliveries[0].complex_location,
      complex_name: session.deliveries[0].complex_name,
    };

    try {
      const res = await monitorResidentAuth(payload);
      const newDeliveries = res?.data?.session_data?.deliveries || [];
      if (!newDeliveries.length) return;

      const updated = session.deliveries.map((old) => {
        const match = newDeliveries.find(
          (n) => n.resident_token === old.resident_token
        );
        return match && match.is_authenticated !== old.is_authenticated
          ? { ...old, is_authenticated: match.is_authenticated }
          : old;
      });

      // Only update if deliveries actually changed
      if (
        JSON.stringify(updated) !==
        JSON.stringify(previousDeliveriesRef.current)
      ) {
        previousDeliveriesRef.current = updated;
        setSession((prev) => ({ ...prev, deliveries: updated }));
      }
    } catch (err) {
      console.error("Poll error:", err);
    }
  }, [session, setSession]);

  useEffect(() => {
    if (!session?.deliveries?.[0]?.session_file_name) return;

    // Initial poll
    pollResidentAuth();

    // Set up interval
    intervalRef.current = setInterval(pollResidentAuth, interval);

    // Cleanup
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [pollResidentAuth, interval]);

  return { pollResidentAuth };
};
